export default __webpack_public_path__ + "static/media/Legguards of the Crimson Fort.595b0d54.jpg";